<template>
  <div class="service-wrap pt-20 pb-20">
    <div class="container">
      <!-- En-tête -->
      <div class="row mb-5">
        <div>
            <!-- <h3 class="section-title">Disciples d’Emmaüs</h3> -->
            <p class="section-text">
              Sont Auditeurs, ceux qui participent par une présence active à tous les cours. Ils ne se soumettent ni aux devoirs ni aux examens. A la fin de leur formation, ils ont une attestation d’auditeurs.
            </p>
        </div>
      </div>
      <div class="row g-4">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-6"
              v-for="etu in etudiants"
              :key="etu.id"
            >
              <div class="prof-mini-card">
                <img
                  v-if="etu.user?.urlImage"
                  :src="getImageUrl(etu.user.urlImage)"
                  alt="Photo disciple"
                  class="prof-photo"
                />

                <img
                  v-else
                  :src="defaultPhoto"
                  alt="Photo par défaut"
                  class="prof-photo"
                />
                <h5 class="prof-mini-name">
                  <router-link
                    :to="`/disciplesEmmaius/${etu.id}`"
                    class="prof-link"
                  >
                    {{ etu.nom }} {{ etu.prenom }}
                  </router-link>
                </h5>
              </div>
            </div>
      </div>
      <div class="mt-4">
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/services/ApiService";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import debounce from "lodash/debounce";

interface Etudiant {
  id: number;
  nom: string;
  prenom: string;
  photo: string;
  autreQualification:string
 user?:User
}
interface User {
  urlImage?: string
}


export default defineComponent({
  name: "LesDisciplesEmmaus",
  components: { PaginationComponent },

  setup() {
    const etudiants = ref<Etudiant[]>([]);
    const defaultPhoto = "/22.png";

    const page = ref(1);
    const limit = ref(12);
    const totalPages = ref(0);
    const totalElements = ref(0);
    const searchTerm = ref('');
   

    // Pagination handler
    const handlePaginate = ({ page_: newPage, limit_: newLimit }) => {
      page.value = newPage;
      limit.value = newLimit;
      getTreeDisciples(newPage, newLimit);
    };
    function rechercher(){
      getTreeDisciples(page.value, limit.value, searchTerm.value );
    }
    // Chargement des étudiants
    const getTreeDisciples = async (pageNum = 1, limi = 12, searchTerm='') => {
      try {
        const { data } = await ApiService.get(
          `/etudiants/categorie/Auditeur?page=${pageNum}&limit=${limi}&mot=${searchTerm}&`
        );
        etudiants.value = data.data.data;
        console.log("gggg",etudiants.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;

      } catch (error) {
        console.error("Erreur chargement disciples :", error);
      }
    };
    function getImageUrl(filename?: string) : string {
      if (!filename) return ''
      return `${ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]}uploads/Users/${filename}`; }

    // Chargement initial
    onMounted(() => {
      getTreeDisciples(page.value, limit.value);
    });

    return {
      etudiants,
      defaultPhoto,
      page,
      limit,
      totalPages,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      getImageUrl
    };
  },
});
</script>

<style scoped>
  .section-text {
    font-size: 20px
  }
  .prof-mini-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 6px 18px rgba(0,0,0,0.1);
  transition: 0.3s;
}

.prof-mini-card:hover {
  transform: translateY(-6px);
}

.prof-photo {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #ffc107;
  margin-bottom: 10px;
}

.prof-mini-name {
  font-weight: 800;
  color: #0b1b3f;
  cursor: pointer;
}

.prof-mini-name:hover {
  color: #ffc107;

  .year-simple {
  margin-bottom: 20px;
}

.year-title {
  font-weight: 800;
  color: #0b1b3f;
}

.matiere-list {
  padding-left: 18px;
}

.matiere-list li {
  list-style: disc;
  padding: 3px 0;
}
.prof-link {
  text-decoration: none;
  color: inherit;
}

.prof-link:hover {
  color: #ffc107;
}

}

.search-wrapper {
  display: flex;
  justify-content: flex-start;
}

.search-box {
  position: relative;
  width: 100%;
  max-width: 380px;
}

.search-box input {
  width: 200%;
  height: 48px;
  padding: 0 50px 0 18px;
  border-radius: 15px;
  border: 2px solid #e6e6e6;
  font-size: 20px;
  color: #0b1b3f;
  transition: all 0.3s ease;
  background-color: #fff;
}

.search-box input::placeholder {
  color: #999;
  font-size: 20px;
}

.search-box input:focus {
  outline: none;
  border-color: #ffc107;
  box-shadow: 0 0 0 4px rgba(255, 193, 7, 0.15);
}

.search-box button {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #ffc107;
  font-size: 18px;
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}

.search-box button:hover {
  color: #0b1b3f;
  transform: translateY(-50%) scale(1.1);
}

/* Responsive */
@media (max-width: 576px) {
  .search-wrapper {
    justify-content: center;
  }

  .search-box {
    max-width: 100%;
  }
}

</style>